import { render } from "./VideosPlayer.vue?vue&type=template&id=078a0a59&scoped=true"
import script from "./VideosPlayer.vue?vue&type=script&lang=js"
export * from "./VideosPlayer.vue?vue&type=script&lang=js"

import "./VideosPlayer.vue?vue&type=style&index=0&id=078a0a59&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078a0a59"]])

export default __exports__